import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { getWorkingHoursFilterOptions } from "../../../utils/workingHoursOptions";
import FilterInput from "../FilterInput";

const WorkingHoursFilterInput = ({
  name,
  placeholder,
  labels,
  value,
  onChange,
}) => {
  const options = useMemo(
    () => getWorkingHoursFilterOptions(labels),
    [labels],
  );

  return (
    <FilterInput
      name={name}
      placeholder={placeholder}
      value={value}
      options={options}
      onChange={onChange}
    />
  );
};

WorkingHoursFilterInput.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  labels: PropTypes.objectOf(PropTypes.string),
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

WorkingHoursFilterInput.defaultProps = {
  name: "workingHours",
  labels: {},
  value: null,
};

export default WorkingHoursFilterInput;
